import Task from "../../../lib/html5-software-library/src/ranj/util/executor/Task";
import Config from "../core/config/Config";
import GoogleAnalyticsConfig from "./GoogleAnalyticsConfig";
import GoogleAnalyticsEvent from "./GoogleAnalyticsEvent";

export default class InitGoogleAnalyticsTask extends Task {
    /**
     * Task to load and initialize GoogleAnalytics
     * @param {soma.EventDispatcher} dispatcher - the soma EventDispatcher
     * @param {Config} config
     * @param {GoogleAnalyticsConfig} googleAnalyticsConfig
     */
    constructor(dispatcher, config, googleAnalyticsConfig) {
        super();
        this._dispatcher = dispatcher;
        this._config = config;
        this._googleAnalyticsConfig = googleAnalyticsConfig;
    }

    async execute(callback) {
        try {
            this._initializeConfig();
            await this._initializeGoogleAnalytics();
        } catch (error) {
            console.error(error);
        } finally {
            callback();
        }
    }

    _initializeConfig() {
        const analyticsJson = this._config.getValue("googleanalytics");
        this._googleAnalyticsConfig.setPropertiesFromObject(analyticsJson);
    }

    async _initializeGoogleAnalytics(timeout = 10000) {
        const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => reject(new Error('Google Analytics initialization timed out')), timeout)
        );

        const gaInitializationPromise = new Promise((resolve, reject) => {
            // Load Google Analytics gtag.js
            // See: https://developers.google.com/analytics/devguides/collection/gtagjs
            const script = document.createElement("script");
            document.getElementsByTagName('body')[0].appendChild(script);
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                window.gtag = function () { window.dataLayer.push(arguments); };
                window.gtag('js', new Date());

                // Start GA session
                this._dispatcher.dispatch(GoogleAnalyticsEvent.INIT);
                this._dispatcher.dispatch(GoogleAnalyticsEvent.SESSION_START);

                resolve();
            };
            script.onerror = () => {
                console.error("Failed to load Google Analytics script.");

                reject();
            }
            const measurementId = this._googleAnalyticsConfig.trackingId;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        });

        return Promise.race([timeoutPromise, gaInitializationPromise]);
    }
}
